export class ItemBundlesAddModel {
    id: number;
    item_bundles:number;
    bundleId:number;
    hide_price:number;
    status: boolean;    
}
